"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "multipleAttendeeCameraStatusChanged", {
  enumerable: true,
  get: function get() {
    return _multipleAttendeeCameraStatusChanged["default"];
  }
});
var _multipleAttendeeCameraStatusChanged = _interopRequireDefault(require("./multipleAttendeeCameraStatusChanged"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }